<template>
  <div>
    <card>
      <div style="display: flex; justify-content: space-between;">
        <div class="">
          <h4>{{title}}</h4>
        </div>
        <div style="display: flex; justify-items: end;" v-if="reportname === 'order_ebarimts'">
          <base-button type="primary" v-on:click="sendEbarimt()">Ибармт илгээх</base-button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-3">
              <p class="category">Интервал</p>
              <el-select class="select-primary" v-on:change="changeDateRange()" size="small" placeholder="Интервал сонгох" v-model="date_range">
                <el-option v-for="option in dateRangeList" class="select-primary" :value="option.value" :label="option.label" :key="option.label" ></el-option>
              </el-select>
            </div>
            <div class="col-md-3">
              <p class="category">Эхлэх</p>
              <base-input>
               <el-date-picker type="datetime" placeholder="Эхлэх цаг" default-time="08:00:00" format="yyyy-MM-dd HH:mm" v-model="start_time_picker" ></el-date-picker>
              </base-input>
            </div>
            <div class="col-md-3">
              <p class="category">Дуусах</p>
              <base-input>
                <el-date-picker type="datetime" placeholder="Дуусах цаг" default-time="08:00:00" format="yyyy-MM-dd HH:mm" v-model="end_time_picker" ></el-date-picker>
              </base-input>
            </div>
            <div class="col-md-2">
              <!-- <div v-for="option in report_params.single_select" v-bind:key="option.key">
                <p class="category">{{option.label}}</p>
                <el-select class="select-primary" size="small" :placeholder="option.placeholder" v-model="report_options[option.key]">
                  <el-option v-for="eloption in dateFormatList" class="select-primary" :value="eloption.value" :label="eloption.label" :key="eloption.label"></el-option>
                </el-select>
              </div> -->
              <div v-for="(option, key, index) in report_params.single_select" :key="option.key">
                <p class="category">{{option.label}}</p>
                <el-select v-if="Object.prototype.hasOwnProperty.call(option, 'data_url') && option.data_url !== ''" filterable  collapse-tags class="select-info" size="small" v-model="report_options[option.key]" :placeholder="option.placeholder">
                  <el-option v-for="(option, i) in single_select[index]" class="select-info" :value="option.value"  :label="option.optionname" :key="i" ></el-option>
                </el-select>
                <el-select v-else class="select-primary" size="small" :placeholder="option.placeholder" v-model="report_options[option.key]">
                  <el-option v-for="eloption in dateFormatList" class="select-primary" :value="eloption.value" :label="eloption.label" :key="eloption.label"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div v-for="(option, key, index) in report_params.multi_select" :key="option.key + index">
              <p class="category">{{option.label}}</p>
              <el-select filterable multiple  collapse-tags class="select-info" size="small" v-model="report_options[option.key]" :placeholder="option.placeholder" style="margin-top: 5px; margin-bottom: 10px;">
                <el-option class="select-info" value="All" label="Бүгд" key="-1" v-on:click.native="changeMultiSelect(option.key, multi_select[key])"></el-option>
                <el-option v-for="(option, i) in multi_select[key]" class="select-info" :value="option.value"  :label="option.optionname" :key="i" ></el-option>
              </el-select>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 0px; margin-bottom: 10px;">
            <div class="col-md-12">
              <base-checkbox inline v-for="option in report_params.check" v-bind:key="option.key" v-model="extra_options[option.key]" >{{option.label}}</base-checkbox>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <base-button type="primary" :disabled="loading" v-on:click="getReportResult">Get Report</base-button>
        </div>
        <div class="col-md-2">
          <el-tooltip placement="top">
            <template #content>Хамгийн ихдээ 3 сараар<br />татагдахыг анхаарна уу !!!</template>
            <base-button type="primary" v-on:click="getReportDownloadResult">Тайлан татах</base-button>
          </el-tooltip>
        </div>
      </div>
    </card>
    <card v-if="gotReport" card-body-classes="table-full-width">
      <div>
        <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <el-select class="select-primary mb-3 pagination-select" v-model="pagination.perPage" placeholder="Per page" >
            <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item" ></el-option>
          </el-select>
          <base-input>
            <el-input type="search" class="mb-3 search-input" clearable prefix-icon="el-icon-search" placeholder="Search records" v-model="searchQuery" aria-controls="datatables" ></el-input>
          </base-input>
          <base-button type="primary" @click="changeTable">Хөл дүн харах</base-button>
        </div>
          <!-- <base-button v-if="!role.includes('employee') && !role.includes('menu_editor')" type="primary" size="sm" simple v-on:click="exportXLSX">export to excel</base-button>-->
        <div v-if="reportData.is_server_pagination === true">
          <el-table :height="height" :data="tableData" show-summary :summary-method="getSummaries" ref="table" @filter-change="filterChange" >
            <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" :formatter="column.formatter" :filters="column.filters" :filter-method="column.filterHandler" ></el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next" :total="pagination.total" :page-size="pagination.perPage" :current-page.sync="pagination.currentPage" @current-change="setPage"></el-pagination>
        </div>
        <div v-else-if="reportData.is_server_pagination !== true">
          <el-table :height="height" :data="queriedData" show-summary :summary-method="getSummaries" ref="table" @filter-change="filterChange" >
            <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" :formatter="column.formatter" :filters="column.filters" :filter-method="column.filterHandler" ></el-table-column>
          </el-table>
          <div class>
            <p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
          </div>
          <base-pagination class="pagination-no-border" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total"  ></base-pagination>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import { BaseCheckbox } from "src/components/index";
import { TimeSelect, DatePicker, Select, Option, Pagination } from "element-ui";
import { Table, TableColumn } from "element-ui";
import { BasePagination } from "src/components";
import Fuse from "fuse.js";
import { getGroups } from "@/utils/auth.js";
// import XLSX, { writeFile } from "xlsx";
import { getToken } from "@/utils/auth.js";
// Огнооны сонголтууд харуулахад хэрэглэх дата авах
import { getDateFormatList, getDateRangeList, getDateRangeValues } from "./dateRange.js";

// Хоёр object-ийг нэгтгэх
function extend(obj, src) {
  for (var key in src) {
    if (src.hasOwnProperty(key)) obj[key] = src[key];
  }
  return obj;
}

export default {
  name: "starter-page",
  components: {
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Option.name]: Option,
    [Select.name]: Select,
    BasePagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination
  },
  computed: {
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  mounted() {
    this.changeDateRange();
    getGroups().then(data => {
      this.role = data;
    })
  },
  created() {
    this.dateFormatList = getDateFormatList()
    this.dateRangeList = getDateRangeList()
    this.dateRangeValues = getDateRangeValues()
    this.clearTable();
    getToken().then(data => {
      this.token = data;
      this.getReport();
    });
  },
  data() {
    return {
      multi_select: {},
      single_select: [],
      loading: false,
      gotReport: false,
      report_options: {
        show_date: "%Y%m%d",
        show_time: false,
        start_time: null,
        end_time: null,
        array_outlets: []
      },
      start_time_picker: null,
      end_time_picker: null,
      report_params: [],
      extra_options: {},
      outletList: [],
      title: "Report",
      reportname: null,
      date_range: "today",
      dateFormatList: [],
      dateRangeList: [],
      dateRangeValues: [],
      pagination: {
        perPage: 500,
        currentPage: 1,
        perPageOptions: [10, 20, 50, 100, 250, 500],
        total: 0
      },
      searchQuery: "",
      propsToSearch: [],
      propsToFilter: [],
      propsToSum: [],
      propsToFormat: [],
      propsToAverage: [],
      propsToCount: [],
      tableColumns: [],
      tableData: null,
      rawTableData: [],
      searchedData: [],
      fuseSearch: null,
      token: "",
      role: [],
      reportData: [],
      resultRep: null,
      offset: 0,
      height: ''
    };
  },
  methods: {
    setPage (val) {
      this.pagination.currentPage = val
      if (val < 2) {
        this.offset = 0
      } else {
        this.offset = parseInt(val - 1) * this.pagination.perPage
      }
      this.getReportResult()
    },
    changeMultiSelect (key, array) {
      if(this.report_options[key].indexOf('All')>=0){
        array.forEach(element => {
          if(this.report_options[key].indexOf(element.value)>=0)
            console.log('baina')
          else
            this.report_options[key].push(element.value)
        })
      }
      else{
        array.forEach(element => {
          if(this.report_options[key].indexOf(element.value)>=0)
             this.report_options[key].splice(this.report_options[key].indexOf(element.value),1)
         })
      }
    },
    filterChange(a) {
      let tableData = this.rawTableData;
      for (let i in a) {
        if (a[i].length == 0) break;
        tableData = tableData.filter(dataNews => {
          return Object.keys(dataNews).some(key => {
            return a[i].indexOf(String(dataNews[key])) > -1;
          });
        });
      }
      this.tableData = tableData;
    },
    // Тайлангийн мэдээллийн авах - single record
    async getReport() {
      let self = this
      await this.getUserToken()
      this.clearTable();
      this.clearColumnProps();
      const baseURI =
        process.env.VUE_APP_reportURI + "?id=" + this.$route.params.id;
      try {
        this.$http
          .get(baseURI, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.token
            }
          })
          .then(result => {
            if (result.data) {
              this.reportData = result.data
              this.title = result.data.title;
              this.reportname = result.data.reportname;
              // this.multi_select = [];
              this.multi_select = {};
              this.single_select = [];
              //parse options for reportGroup
              let group_params = [];
              if (result.data.ReportGroup && result.data.options) {
                group_params = JSON.parse(
                  JSON.stringify(result.data.options)
                );
              }
              // parse options for report
              let params = result.data.options
                ? JSON.parse(JSON.stringify(result.data.options))
                : [];
              this.report_params = extend(group_params, params);
              for (let opt in this.report_params.check) {
                if (this.report_params.check.hasOwnProperty(opt)) {
                  this.extra_options[this.report_params.check[opt].key] = this.report_params.check[opt].value || false;
                }
              }
              let single = this.report_params.single_select
                ? JSON.parse(JSON.stringify(this.report_params.single_select))
                : []
              let single_select_urls = []
              for (let index in single) {
                console.log('single[index]', single[index])
                const element = single[index]
                single_select_urls.push(element.data_url)
              }
              let single_select_requests = single_select_urls.map(url => this.$http.get(url, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + this.token
                }
              }));

            // Promise.all waits until all jobs are resolved
              Promise.all(single_select_requests)
              .then(responses => responses.forEach(
                response => this.single_select.push(response.data)
              ));

              let multi = this.report_params.multi_select
                ? JSON.parse(JSON.stringify(this.report_params.multi_select))
                : []
              let urls = []
              for (let index in multi) {
                const element = multi[index]
                if (Object.prototype.hasOwnProperty.call(element, 'data_url') && element.data_url && element.data_url.length > 0) {
                  urls.push({ url: element.data_url, title: index})
                } else {
                  self.multi_select[index] = element.data
                }
              }
              // map every url to the promise of the fetch

            // Promise.all waits until all jobs are resolved
              Promise.all(urls.map(el => {
                this.$http.get(el.url,
                  { headers: { "Content-Type": "application/json", Authorization: "Bearer " + this.token }}
                  ).then(response => {
                    self.multi_select[el.title] = response.data
                  })
              }))
              this.$forceUpdate()
              // multi.forEach(element => {
              //   console.log(element)
              // });

              // parse column options
              let col_options = JSON.parse(
                JSON.stringify(result.data.colnames)
              );
              this.propsToSum = col_options.summaries
                ? col_options.summaries
                : [];
              this.propsToFormat = col_options.amounts
                ? col_options.amounts
                : [];
              this.propsToAverage = col_options.average
                ? col_options.average
                : [];
              this.propsToFilter = col_options.filters
                ? col_options.filters
                : [];
              this.propsToCount = col_options.count
                ? col_options.count
                : [];
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    onNewRoute() {
      this.pagination = {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 20, 50, 100, 250, 500],
        total: 0
      }
      this.offset = 0
      this.getReport()
    },
    // Тайлангийн үр дүнг авах
    async getReportResult() {
      this.loading = true;
      this.clearTable();
      const baseURI = process.env.VUE_APP_reportExecURI;
      try {
        this.report_options.start_time = this.getDateStr(
          this.start_time_picker
        );
        this.report_options.end_time = this.getDateStr(this.end_time_picker);

        if (this.reportData.is_server_pagination === true) {
          this.resultRep = await this.$http.post(
          baseURI,
          {
            report_name: this.$route.params.id,
            ...this.report_options,
            ...this.extra_options,
            size: this.pagination.perPage,
            from: this.offset
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.token
            }
          }
        );
          this.tableData = this.resultRep.data.data ? this.resultRep.data.data : [];
          this.rawTableData = this.resultRep.data.data ? this.resultRep.data.data : [];
          this.pagination.total = this.resultRep.data.total
        } else {
          this.resultRep = await this.$http.post(
          baseURI,
          {
            report_name: this.$route.params.id,
            ...this.report_options,
            ...this.extra_options
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.token
            }
          }
        );
          this.tableData = this.resultRep.data ? this.resultRep.data : [];
          this.rawTableData = this.resultRep.data ? this.resultRep.data : [];
        }
        this.gotReport = true;

        if (this.tableData.length > 0) {
          this.propsToSearch = Object.keys(this.tableData[0]);
          this.tableColumns = this.propsToSearch.map(function(col) {
            return {
              prop: col,
              label: col.replace("_", " ")
            };
          });

          this.tableColumns.forEach(this.setFormatter);

          this.fuseSearch = new Fuse(this.tableData, {
            keys: this.propsToSearch,
            threshold: 0.3
          });
        }
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "danger",
          message: `Error! ${this.title}`,
          icon: "tim-icons icon-bell-55"
        });
      }
      this.loading = false
      this.$forceUpdate()
    },
    async getUserToken() {
      const token = await getToken()
      this.token = token
    },
    changeDateRange() {
      this.start_time_picker = this.dateRangeValues[this.date_range][0];
      this.end_time_picker = this.dateRangeValues[this.date_range][1];
    },
    getDateStr(d) {
      var datestring =
        d.getFullYear() +
        "-" +
        ("0" + (d.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + d.getDate()).slice(-2) +
        " " +
        ("0" + d.getHours()).slice(-2) +
        ":" +
        ("0" + d.getMinutes()).slice(-2);
      return datestring;
    },
    // Тайлан харуулах хүснэгтийг хоослох
    clearTable() {
      this.tableData = [];
      this.tableColumns = [];
      this.gotReport = false;
    },
    // Тайлан харуулах хүснэгтийн багануудын тохиргоог арилгах
    clearColumnProps() {
      this.propsToSearch = [];
      this.propsToFilter = [];
      this.propsToSum = [];
      this.propsToAverage = [];
      this.propsToCount = [];
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    // Мөнгөн дүнгийн харуулах формат болон баганын филтэр тохируулах
    setFormatter(item, index) {
      if (this.propsToFormat.includes(item.prop)) {
        item.formatter = (row, column, value, index) => {
          return Number(value)
            .toFixed(0)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        };
      }
      if (this.propsToFilter.includes(item.prop)) {
        let tmp = new Set(
          this.tableData.map(function(row) {
            return row[item.prop];
          })
        );

        if (tmp && tmp.size > 1) {
          item.filters = Array.from(tmp).map(val => ({
            text: val,
            value: val
          }));
          item.filterHandler = this.filterHandler;
        }
      }
    },
    // Хөл дүн тооцоолох
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total Cost";
          return;
        }
        if (
          !this.propsToSum.includes(column.property) &&
          !this.propsToAverage.includes(column.property) &&
          !this.propsToCount.includes(column.property)
        ) {
          sums[index] = "";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        const count =  values.length
        if (this.propsToCount.includes(column.property)) {
          sums[index] = count
        } else {
          if (!values.every(value => isNaN(value))) {
            let val = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            if (this.propsToAverage.includes(column.property)) sums[index] = parseFloat(parseFloat(val / data.length).toFixed(2))
            if (this.propsToSum.includes(column.property)) sums[index] = val.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          } else sums[index] = "N/A";
        }
      });
      return sums;
    },
    // exportXLSX() {
    //   var wb = XLSX.utils.book_new();
    //   var ws_name = "SheetJS";
    //   var ws = XLSX.utils.json_to_sheet(this.tableData);
    //   XLSX.utils.book_append_sheet(wb, ws, ws_name);
    //   XLSX.writeFile(wb, `${this.$route.params.id}.xlsx`);
    // },
    async getReportDownloadResult() {
      const baseURl = process.env.VUE_APP_reportExecDownloadURI;
      try {
        this.report_options.start_time = this.getDateStr(
          this.start_time_picker
        );
        this.report_options.end_time = this.getDateStr(this.end_time_picker);
        const result = await this.$http.post(
          baseURl,
          {
            report_name: this.$route.params.id,
            ...this.report_options,
            ...this.extra_options
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.token
            }
          }
        );
        if(result.data.status === "success"){
          window.open(result.data.data, '_blank')
        } else {
          this.$notify({
            type: "danger",
            message: "Амжилтгүй",
            icon: "tim-icons icon-bell-55"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Таньд тайлан татах эрх байхгүй байна !!!",
          icon: "tim-icons icon-bell-55"
        });
      }
    },
    changeTable () {
      if (this.height === 300) {
        this.height = ''
      } else this.height = 300
    },
    async sendEbarimt () {
      try {
        const baseURI = process.env.VUE_APP_reportURI
        const { data } = await this.$http.get(
          `${baseURI}/ebarimt/sendData`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.token
            }
          }
        );
        this.$notify({
          type: "success",
          message: (data && data.message) || "Ибаримт дата илгээгдлээ",
          icon: "tim-icons icon-bell-55"
        });
      } catch (error) {
        console.log(JSON.stringify(error));
        this.$notify({
          type: "danger",
          message: `Error!`,
          icon: "tim-icons icon-bell-55"
        });
      }
    }
  },
  watch: {
    $route: "onNewRoute",

    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */

    searchQuery(value) {
      let result = this.rawTableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.tableData = result;
    }
  }
};
</script>
<style></style>
